import React from 'react';
import { ConstantPermissions } from 'contexts/useConstant';
import Entry from 'components/Tvendo/Inventory/Operations/Kardex/KardexSharedFile';

export default function () {
  return (
    <Entry
      title="entradas"
      excelName="entradas"
      type="ET" //ET = entradas
      entity="logi/entry"
      permissions={{
        store: ConstantPermissions.LOGI_ENTRIES_STORE,
        show: ConstantPermissions.LOGI_ENTRIES_SHOW,
        delete: ConstantPermissions.LOGI_ENTRIES_DELETED
      }}
    />
  );
}
